// extracted by mini-css-extract-plugin
module.exports = {"root":"loading-dots_root__29XlM","blink":"loading-dots_blink__23KLa"};